import { FormDataHubAdjustmentTaxInvoice } from '@/form/form-data/FormDataHubAdjustmentTaxInvoice';
export const getInitialState = () => ({
    dialogDetail: {
        id: 0,
        hubId: '',
        month: 0,
    },
    isEditMode: false,
    taxInvoiceData: null,
    invoicerFormData: new FormDataHubAdjustmentTaxInvoice(),
});
const states = getInitialState();
export default states;
